import Widget from "./widget";

export default Widget;